<template>
    <div id="app">
        <Index/>
    </div>
</template>

<script>
    import Index from './components/Index.vue'

    export default {
        name: 'App',
        components: {
            Index
        }
    }
</script>

<style>
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    .red {
        background: #961620;
    }

    .green {
        background: #5c912c;
    }

    .blue {
        background: #3077e3;
    }

    .purple {
        background: #96218d;
    }

    .yellow {
        background: #9ca02f;
    }

    .one {
        background: #ffd900;
        border: 2px solid #ffd900;

    }

    .two {
        background: #ffb806;
        border: 2px solid #ffb806;

    }

    .three {
        background: #ff9204;
        border: 2px solid #ff9204;

    }

    .four {
        background: #ff4602;
        border: 2px solid #ff4602;

    }

    .five {
        background: #c51d00;
        border: 2px solid #c51d00;

    }
</style>
